import * as Sentry from '@sentry/browser';
/*
 * Make requests to some backend
 * Based on https://github.com/sveltejs/realworld/blob/master/src/node_modules/api.js
 */
async function send({ method, data = null, headers = {} }) {
	const path =
		typeof window === 'undefined' ? import.meta.env.VITE_PROTECTED_GRAPHQL_ENDPOINT : '/api';

	const opts = {
		method,
		headers,
		body: '',
	};

	if (data) {
		if (!data.type) {
			opts.headers['Content-Type'] = 'application/json';
			opts.body = JSON.stringify(data);
		}
		opts.headers['Authorization'] = `Bearer 2pAZzQbGZfLtWiAtVa0xu0QBT9kcQCUbmB0s6Tt6`;
	}

	if (import.meta.env.VITE_DEBUG_MODE) {
		console.log(method, path);
		console.log(opts);
	}
	const response = await fetch(path, opts);
	const json = await response.json();
	if (import.meta.env.VITE_DEBUG_MODE) {
		console.log('DEBUG:', json);
	}
	if (json.errors) {
		json.errors.forEach((e) => {
			const err = new Error(e.message);
			Sentry.captureException(err);
		});
	}
	return { response, json };
}

/*
 * Shortcut methods for send
 */
export function get(headers = {}) {
	return send({ method: 'GET', headers });
}

export function del(data, headers = {}) {
	return send({ method: 'DELETE', data, headers });
}

export function post(data, headers = {}) {
	return send({ method: 'POST', data, headers });
}

export function put(data, headers = {}) {
	return send({ method: 'PUT', data, headers });
}
